module.exports = __webpack_public_path__ + "img/FriendlyFireColored.32964fc7.png";